import { useDispatch } from "react-redux";
import { PatientProfileTabs } from "../pages/PatientProfile/PatientProfileTabs";
import { Summary } from "../pages/PatientProfile/Summary";
import React, { useEffect } from "react";
import { setPageTitle } from "../store/slices/pageTitleSlice";

export const ProfilePageLoader = () => {
    const dispatch = useDispatch();
    useEffect( () => {
        dispatch(setPageTitle('Patient Profile | Spire360'));
    }, []);
    const PLACEHOLDER = <span className="placeholder-wave">
        <span className="placeholder w-100"></span>
    </span>;

    const USER_PLACEHOLDER = <span className="placeholder-wave">
        <span className="placeholder w-100"></span>
    </span>;
    return (
        <main className="main">
            <div
                className="d-flex align-items-center px-3 px-md-4 px-lg-5 py-2 border-bottom"
                aria-label="breadcrumb"
            >
                <div className="flex-fill">
                    <ol className="breadcrumb ms-2">
                        <li className="breadcrumb-item breadcrumb-item-first">
                            <a href="javascript:void(0);">
                                <span className="material-symbols-outlined fs-16">home</span>
                            </a>
                        </li>
                        <li className="breadcrumb-item">
                            <a href="javascript:void(0);">Patient</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                            Profile
                        </li>
                    </ol>
                    <div className="d-flex py-1">
                        <div className="flex-fill d-flex">
                            <div className="d-flex align-items-center pe-3 border-end">
                                <span className="d-block user-icon me-2">
                                    {USER_PLACEHOLDER}
                                </span>
                            </div>
                            <div className="w-70">
                                {PLACEHOLDER}
                                {PLACEHOLDER}
                            </div>
                        </div>
                        <div className="align-items-center w-20">
                            {PLACEHOLDER}
                            {PLACEHOLDER}
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center px-4 bg-teal-light">
                <ul className="tabs flex-fill">
                    <li className="tabs__item">
                        <span className="tabs__link">
                            &nbsp;
                        </span>
                    </li>
                </ul>
            </div>
            <div className="tabs__content">
                <div className="row g-3">
                    <div className="col-12 col-lg-6">
                        <div className="sidebar h-100">
                            <div className="sidebar__header style-02">
                                <div className='d-flex'>
                                    <div className='flex-fill d-flex'>
                                        <div className="w-60">
                                            {PLACEHOLDER}
                                        </div>
                                    </div>
                                    <div className='ps-4 w-15'>
                                        {PLACEHOLDER}
                                    </div>
                                </div>
                            </div>
                            <div className="sidebar__content">
                                <div className="row g-3">
                                    <div className="col-12 col-lg-6">
                                        <div className='border p-3 rounded-3 mt-1'>
                                            <div className='d-flex'>
                                                <div className='flex-fill'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                                <div className='w-30 ms-auto'>
                                                    {PLACEHOLDER}
                                                </div>
                                            </div>
                                            <hr className='my-2' />
                                            <div className='d-flex align-items-center text-center'>
                                                <div className='w-3rd'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                                <div className='w-3rd'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                                <div className='w-3rd'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6">
                                        <div className='border p-3 rounded-3 mt-1'>
                                            <div className='d-flex'>
                                                <div className='flex-fill'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                                <div className='w-30 ms-auto'>
                                                    {PLACEHOLDER}
                                                </div>
                                            </div>
                                            <hr className='my-2' />
                                            <div className='d-flex align-items-center text-center'>
                                                <div className='w-3rd'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                                <div className='w-3rd'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                                <div className='w-3rd'>
                                                    <div className="w-50">{PLACEHOLDER}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex mt-4">
                                    <span className="d-block user-icon me-3">
                                        {USER_PLACEHOLDER}
                                    </span>
                                    <div className='flex-fill'>
                                        <div className="d-flex text-primary fw-semibold">
                                            <div className='flex-fill'>
                                                <div className="w-50">{PLACEHOLDER}</div>
                                                <div className="w-50">{PLACEHOLDER}</div>
                                                <div className="w-50">{PLACEHOLDER}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='text-end w-20 ms-auto'>
                                    {PLACEHOLDER}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="sidebar h-100">
                            <div className="sidebar__header style-02">
                                <div className='d-flex'>
                                    <div className='flex-fill d-flex'>
                                        <div className="w-60">
                                            {PLACEHOLDER}
                                        </div>
                                    </div>
                                    <div className='ps-4 w-15'>
                                        {PLACEHOLDER}
                                    </div>
                                </div>
                            </div>
                            <div className="sidebar__content p-0">
                                <div className="bg-white rounded p-0 fs-12 sidebar__content-scroll">
                                    {
                                        Array.from({ length: 4 }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className="d-flex d-block p-3 hover-bg">
                                                    <strong className="w-55">
                                                        <div className="w-50">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </strong>
                                                    <strong className="w-15">
                                                        <div className="w-50">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </strong>
                                                    <strong className="w-15">
                                                        <div className="w-50">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </strong>
                                                    <strong className="w-15">
                                                        <div className="w-50">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <hr className="m-0" />
                                            </React.Fragment>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="sidebar h-100">
                            <div className="sidebar__header style-02">
                                <div className='d-flex'>
                                    <div className='flex-fill d-flex'>
                                        <div className="w-60">
                                            {PLACEHOLDER}

                                        </div>
                                    </div>
                                    <div className='ps-4 w-15'>
                                        {PLACEHOLDER}

                                    </div>
                                </div>
                            </div>
                            <div className="sidebar__content p-0">
                                <div className="bg-white rounded p-0 sidebar__content-scroll">
                                    {
                                        Array.from({ length: 3 }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className="p-3">
                                                    <div className="d-flex">
                                                        <div className="flex-fill">
                                                            <span className="text-light fs-11">
                                                                <div className="w-50">
                                                                    {PLACEHOLDER}
                                                                    {PLACEHOLDER}
                                                                </div>
                                                            </span>
                                                        </div>
                                                        <div className="ps-4 w-20">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr className="m-0" />
                                            </React.Fragment>
                                        ))
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="sidebar h-100">
                            <div className="sidebar__header style-02">
                                <div className='d-flex'>
                                    <div className='flex-fill d-flex'>
                                        <div className="w-60">
                                            {PLACEHOLDER}
                                        </div>
                                    </div>
                                    <div className='ps-4 w-15'>
                                        {PLACEHOLDER}
                                    </div>
                                </div>
                            </div>
                            <div className="sidebar__content p-0">
                                <div className="bg-white rounded p-0 fs-12 sidebar__content-scroll">
                                    {
                                        Array.from({ length: 4 }).map((_, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className="d-flex d-block p-3 hover-bg">
                                                    <strong className="w-55">
                                                        <div className="w-50">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </strong>
                                                    <strong className="w-15">
                                                        <div className="w-50">
                                                            {PLACEHOLDER}
                                                        </div>
                                                    </strong>
                                                </div>
                                                <hr className="m-0" />
                                            </React.Fragment>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}